<template>
  <div
    v-if="reseted"
    id="rmpPlayer"
    className="video-player"
  />
</template>

<script>
  export default {
    name: 'VideoPlayer',
    props: {
      src: {
        type: String,
        default: '',
        required: true,
      },
    },
    data () {
      return {
        player: null,
        playerSrc: {
          hls: ' ',
        },
        reseted: true,
        customEventName: '',
        polling: null,
      }
    },
    watch: {
      src (newVal, oldVal) {
        if (newVal) {
          if (this.player) {
            this.player.stop()
            this.player.destroy()
          }
          this.initialize(newVal)
        }
      },
    },
    mounted () {
      this.polling = setInterval(() => {
      }, 1000)
      if (!this.player && this.src.startsWith('http')) {
        this.initialize(this.src)
      }
    },
    beforeDestroy () {
      clearInterval(this.polling)
      if (this.player) {
        this.player.stop()
        this.player.destroy()
      }
    },
    methods: {
      initialize (url) {
        if (!url) return
        if (url) {
          this.playerSrc.hls = url
        }

        const settings = {
          licenseKey: 'amxtbHpteGphbEAxNTYxMTI5',
          src: this.playerSrc,
          // sLiveDvr: true,
          // detectAutoplayCapabilities: true,
          autoplay: true,
          skin: 's2',
          contentMetadata: {},
        }

        // emit event
        const emitPlayerState = (event, value) => {
          if (event) {
            this.$emit(event, this.player)
          }
          if (value) {
            this.$emit(this.customEventName, { [event]: value })
          }
        }

        // eslint-disable-next-line no-undef
        this.player = new RadiantMP('rmpPlayer')
        this.player.init(settings)

        const rmpContainer = document.getElementById('rmpPlayer')

        const self = this
        rmpContainer.addEventListener('warning', function () {
          if (self.player) {
            const d = self.player.getErrorData()
            emitPlayerState('warning', d.event)
            console.log('warning', d)
            if (d.event && d.event.details === 'bufferStalledError') {
            // setNewLink();
            }
          }
        })

        rmpContainer.addEventListener('ready', function () {
          emitPlayerState('ready', true)
        })
      },
    },
  }
</script>

<style>
</style>
